import React from 'react';
import InfoSection from './InfoSection';
import OnlyForm from './OnlyForm';


import Footer from './Footer';


const Home = () => {
    return (
        <div>
            <InfoSection />
            <OnlyForm />

            <Footer />


        </div>
    );
};

export default Home;